export default {
    items: [],
    fields: [
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label: "options",
            _style: "width:10%",
            _classes: "text-center",
            sorter: false,
            filter: false,
        },
    ],
    columnFilterValue: {},
}